var ImageEditor = require('tui-image-editor');
import axios from 'axios';

class TUIImageEditor {
  constructor(contentTUI, urlUpload, vue, data, gfrToken) {
    this.data = data;
    this.contentTUI = contentTUI;
    this.imageEditor = false;
    this.urlUpload = urlUpload;
    this.callback = false;
    this.gfrToken = gfrToken;
    this.vue = vue;

    this.setEditor();
  }

  getLocale() {

    return {
      'Crop': this.vue.$t('ct-toast-label-crop'),
      'DeleteAll': this.vue.$t('ct-toast-label-deleteall'),
      'Delete': this.vue.$t('ct-toast-label-delete'),
      'Undo': this.vue.$t('ct-toast-label-undo'),
      'Redo': this.vue.$t('ct-toast-label-redo'),
      'Reset': this.vue.$t('ct-toast-label-reset'),
      'Rotate': this.vue.$t('ct-toast-label-rotate'),
      'Flip': this.vue.$t('ct-toast-label-flip'),
      'Draw': this.vue.$t('ct-toast-label-draw'),
      'Shape': this.vue.$t('ct-toast-label-shape'),
      'Icon': this.vue.$t('ct-toast-label-icon'),
      'Text': this.vue.$t('ct-toast-label-text'),
      'Mask': this.vue.$t('ct-toast-label-mask'),
      'Filter': this.vue.$t('ct-toast-label-filter')
    };
  }

  getTheme() {
    return {
      'common.bi.image': '',
      'common.bisize.width': '251px',
      'common.bisize.height': '21px',
      'common.backgroundImage': '',
      'common.backgroundColor': '#eff3f863',
      'common.border': '1px solid transparent',

      // header
      'header.backgroundImage': 'none',
      'header.backgroundColor': 'transparent',
      'header.border': '0px',

      // load button
      'loadButton.backgroundColor': '#fff',
      'loadButton.border': '1px solid #ddd',
      'loadButton.color': '#222',
      'loadButton.fontFamily': '\'Noto Sans\', sans-serif',
      'loadButton.fontSize': '12px',

      // download button
      'downloadButton.backgroundColor': '#fdba3b',
      'downloadButton.border': '1px solid #fdba3b',
      'downloadButton.color': 'transparent',
      'downloadButton.fontFamily': '\'Noto Sans\', sans-serif',
      'downloadButton.fontSize': '12px',

      // main icons
      'menu.normalIcon.name': 'icon-d',
      'menu.activeIcon.name': 'icon-b',
      'menu.disabledIcon.name': 'icon-a',
      'menu.hoverIcon.name': 'icon-c',
      'menu.iconSize.width': '24px',
      'menu.iconSize.height': '24px',

      // submenu primary color
      'submenu.backgroundColor': '#eff3f896',
      'submenu.partition.color': '#e5e5e5',

      // submenu icons
      'submenu.normalIcon.name': 'icon-d',
      'submenu.activeIcon.name': 'icon-b',
      'submenu.iconSize.width': '32px',
      'submenu.iconSize.height': '32px',

      // submenu labels
      'submenu.normalLabel.color': '#858585',
      'submenu.normalLabel.fontWeight': 'normal',
      'submenu.activeLabel.color': '#000',
      'submenu.activeLabel.fontWeight': 'normal',

      // checkbox style
      'checkbox.border': '1px solid #ccc',
      'checkbox.backgroundColor': '#fff',

      // rango style
      'range.pointer.color': '#333',
      'range.bar.color': '#ccc',
      'range.subbar.color': '#606060',

      'range.disabledPointer.color': '#d3d3d3',
      'range.disabledBar.color': 'rgba(85,85,85,0.06)',
      'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',

      'range.value.color': '#000',
      'range.value.fontWeight': 'normal',
      'range.value.fontSize': '11px',
      'range.value.border': '0',
      'range.value.backgroundColor': '#f5f5f5',
      'range.title.color': '#000',
      'range.title.fontWeight': 'lighter',

      // colorpicker style
      'colorpicker.button.border': '0px',
      'colorpicker.title.color': '#000'
    };
  }

  setImage(img, name) {
    this.imageEditor.loadImageFromURL(img, name);
  };

  setEditor() {
    var height = (window.innerHeight > 650) ? window.innerHeight * 0.8 : 650;
    var width = ((window.innerWidth > 700) ? window.innerWidth * 0.7 : 700);

    this.imageEditor = new ImageEditor(this.contentTUI, {
      includeUI: {
        loadImage: {
          path: this.data.url,
          name: this.data.name
        },
        locale: this.getLocale(),
        theme: this.getTheme(),
        menuBarPosition: 'bottom',
        crossOrigin: null
      },
      cssMaxWidth: width,
      cssMaxHeight: height,
    });

    let imageEditor = this.imageEditor;

    window.onresize = function() {
      imageEditor.ui.resizeEditor();
    };
  }

  base64ToBlob(data) {
    var mimeString = '';
    var raw, uInt8Array, i, rawLength;
    var rImageType = /data:(image\/.+);base64,/;

    raw = data.replace(rImageType, function(header, imageType) {
      mimeString = imageType;

      return '';
    });

    raw = atob(raw);
    rawLength = raw.length;
    uInt8Array = new Uint8Array(rawLength); // eslint-disable-line

    for (i = 0; i < rawLength; i += 1) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], {type: mimeString});
  }

  upload(file){
    const formData = new FormData();
    formData.append('folder', 'General');
    formData.append('file', file);

    axios.post(this.urlUpload, formData, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${this.gfrToken}`
      },
    })
    .then(response => {
        alert(this.vue.$t("ct-new-file-created"));
        if (typeof this.callback === 'function') {
          this.callback(response.data);
        }
    })
    .catch(error => {
        console.error('Error to upload copy file:', error);
        alert(this.vue.$t('ct-error-to-copy-file'));
        if (typeof this.callback === 'function') {
          this.callback(error);
        }
    })
  }

  async onUpload(blob, imageName) {
    var file = new File([blob], imageName, {type: blob.type});

    await this.upload(file);
  }

  async onSave(callback) {

    var imageName = this.imageEditor.getImageName();
    var dataURL = this.imageEditor.toDataURL();
    var blob, type;
    var supportingFileAPI = !!(window.File && window.FileList && window.FileReader);

    if (typeof callback === 'function'){
      this.callback = callback;
    }

    if (supportingFileAPI) {
      blob = this.base64ToBlob(dataURL);
      type = blob.type.split('/')[1];
      if (imageName.split('.').pop() !== type) {
        imageName += '.' + type;
      }

      await this.onUpload(blob, imageName);
    } else {
      console.log('This browser needs a file-server');
    }
  }
}

export default TUIImageEditor;



// WEBPACK FOOTER //
// ./src/components/general/FilesManager/toast-ui/TUIImageEditor.js